import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { MapZoomContext } from "../../lib/Map/Trimble/components/MapZoomChange";
const styles = theme => ({
  mainContainer: {
    position: "relative",
    width: "30px",
    height: "30px",
  },
  timeContainer: {
    position: "absolute",
    width: "25px",
    height: "26px",
    right: "34px",
    top: "-3px",
    color: theme.TextColor,
    opacity:0.8
  },
  timeWindow1: {
    fontSize: "10px",
    fontWeight: 700,
    textAlign: "right",
  },
  timeWindow2: {
    fontSize: "10px",
    fontWeight: 700,
    marginTop: -6,
    textAlign: "right",
  },
});
class PickupwithTimeWindow extends React.Component {
  constructor(props) {
    super(props);
  }
  static contextType = MapZoomContext;

  render() {
    const { classes, pickupReadyTime, pickupCloseTime } = this.props;
    const { zoomLevel, thresholdZoomLevel } = this.context;
    return (
      <div className={classes.mainContainer}>
        {this.props.wrappedComponent}
        {zoomLevel > thresholdZoomLevel ? (
          <div className={classes.timeContainer}>
            <div className={classes.timeWindow1}>{pickupReadyTime}</div>
            <div className={classes.timeWindow2}>{pickupCloseTime}</div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default withStyles(styles)(PickupwithTimeWindow);
